import { Injectable } from "@angular/core";
import { RestApiService } from "./rest-api.service";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ServiceModel } from "src/models/service";
import { AuthService } from "./auth.service";
import { SignalingImageSituationEnum } from "src/enumerators";

@Injectable({
  providedIn: 'root',
})

export class ServiceModuleService extends RestApiService {
  environmentEndpoint = environment.endpoint();

  _urlService = '/services'
  _urlServiceId = '/services/:id'
  _urlServiceIdFiles = '/services/:id/files'

  constructor(private _http: HttpClient, private _auth: AuthService) {
    super(_http);
  }

  getServices(status = []) {
    const statusJson = JSON.stringify(status);
    let url = this._urlService;
    if (status.length) url += `?status=${statusJson}&`;
    return this.get(url, ServiceModel);
  }

  getServiceId(id) {
    const url = this._urlServiceId.replace(':id', id);
    return this.get(url, ServiceModel);
  }

  createService(service) {
    const url = this._urlService;
    return this.post(url, service, ServiceModel);
  }

  updateService(service, id) {
    const url = this._urlServiceId.replace(':id', id);
    return this.put(url, service, ServiceModel);
  }

  deleteService(id) {
    const url = this._urlServiceId.replace(':id', id);
    return this.del(url, ServiceModel);
  }

  uploadServiceFile(files, id, situation: SignalingImageSituationEnum) {
    const reqHeaders = new HttpHeaders({
      Authorization: `Bearer ${this._auth.getJwtToken()}`,
      FormData: 'true',
    });
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }
    const situationImg = `?situation=${situation}`;
    const url = this.environmentEndpoint + this._urlServiceIdFiles.replace(':id', id) + situationImg;
    return this._http.post(url, formData, { headers: reqHeaders });

  }

  deleteServiceFile(id, fileId) {
    const url = this.environmentEndpoint + this._urlServiceIdFiles.replace(':id', id) + `${fileId}`;
    return this.http.delete(url)
  }
}
